import { clsx } from "clsx";
import { useBuildTablePagination } from "@/hooks/common/table/use-build-table-pagination";
import { PaginationMetadata } from "@/interfaces/api";
import { Icon } from "../../Icon";
import { PaginationButton } from "./PaginationButton";
import { PaginationResult } from "./PaginationResult";
import styles from "./styles.module.css";

export type Props = Readonly<
  PaginationMetadata & {
    totalVisible: number;
    onPageChange: (page: number) => void;
    className?: string;
    isLoading?: boolean;
  }
>;

export const TablePagination = ({
  page: currentPage,
  pageCount,
  total,
  limit,
  className,
  isLoading,
  ...rest
}: Props) => {
  const { pages, handlePageChange } = useBuildTablePagination({
    page: currentPage,
    pageCount,
    ...rest,
  });

  if (!pageCount) {
    return null;
  }

  return (
    <div className={clsx(styles.wrapper, className, { hidden: isLoading })}>
      <PaginationResult currentPage={currentPage} perPage={limit} total={total} />

      <ul className={styles.container}>
        <li>
          <PaginationButton
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            title="previous"
          >
            <Icon name="ChevronLeft" />
          </PaginationButton>
        </li>
        {pages.map((page, index) => (
          <li key={index}>
            <PaginationButton
              onClick={() => handlePageChange(page)}
              disabled={page === "..." || currentPage === page}
              isActive={currentPage === page}
              title={String(page)}
            >
              {page}
            </PaginationButton>
          </li>
        ))}
        <li>
          <PaginationButton
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === pageCount}
            title="next"
          >
            <Icon name="ChevronRight" />
          </PaginationButton>
        </li>
      </ul>
    </div>
  );
};
